__turbopack_context__.v({
  "summary": "ToolThinkingDisplay-module__b6eeoq__summary",
});
